import Cookie from '../cookie'
import Api from '../Api'
import rootUrl from "../rootUrl"

const loginAsUser = {
  namespaced: true,
  state: {
    cookieEmail: null,
    cookieToken: null
  },
  mutations: {
    login(state, { email, token }) {
      Cookie.set('email', email);
      Cookie.set('token', token);
    }
  },
  actions: {
    async getToken({ commit }, id) {
      await Api.get(`/guestroom/users/${id}`)
      .then((response) => {
        const email = response.data.user.email
        const token = response.data.user.authenticationToken
        commit('login', { email, token })
        window.open(rootUrl({ subdomain: 'app' }));
      })
      .catch((error) => {
        var description = 'Sorry, something went wrong. Please try again.'
        commit('notification/show', { type: "error", message: "Wuh-oh!", description: description }, { root: true })
      });
    },
  }
}

export default loginAsUser